import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function WaContactsCard() {
  const [q, setQ] = useState("");
  const [group, setGroup] = useState("");
  const [data, setData] = useState(null);
  const [edit, setEdit] = useState({});
  const load = (g = group) => api.get("/wa/subscribers", { params: { q: q || undefined, group: g || undefined, limit: 25 } }).then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const link = async (m, customer_id) => {
    try { await api.put(`/wa/subscribers/${encodeURIComponent(m)}/link`, { customer_id: customer_id || null }); toast.success(customer_id ? "Linked" : "Unlinked"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not link"); }
  };
  return (
    <section className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5" data-testid="wa-contacts-card">
      <h2 className="text-sm font-bold text-slate-900 mb-1">WhatsApp contacts</h2>
      <p className="text-xs text-slate-500 mb-3">Link or relink a WhatsApp contact to a TedOps customer. Customer records are never changed.</p>
      <div className="flex flex-wrap gap-1.5 mb-2" data-testid="wa-contacts-filter">
        {[["", "All"], ["existing", "Existing customer"], ["standalone", "Standalone contact"], ["needs_matching", "Needs matching"]].map(([k, label]) => (
          <button key={k || "all"} onClick={() => { setGroup(k); load(k); }} data-testid={`wa-contacts-filter-${k || "all"}`}
            className={`text-xs rounded-full px-2.5 py-1 border ${group === k ? "bg-indigo-600 text-white border-indigo-600" : "border-slate-200 text-slate-600"}`}>{label}</button>
        ))}
      </div>
      <div className="flex gap-2"><Input placeholder="Search name, number, email, Superchat ID" value={q} onChange={(e) => setQ(e.target.value)} data-testid="wa-contacts-search" /><Button variant="outline" onClick={() => load()} data-testid="wa-contacts-search-btn">Search</Button></div>
      {data && <div className="text-xs text-slate-400 mt-2">{data.total} contacts</div>}
      <div className="divide-y divide-slate-100">
        {data?.items.map((s) => (
          <div key={s.msisdn} className="py-2 text-sm flex flex-wrap items-center gap-2" data-testid={`wa-contact-${s.msisdn}`}>
            <span className="font-medium text-slate-800">{s.name || "No name"}</span>
            <span className="text-slate-500">{s.msisdn}{s.is_uk === false ? " · international" : ""} · {s.consent_status || "pending_verification"} · {s.match_status || "standalone"}{s.customer_id ? ` · customer #${s.customer_id}` : ""}</span>
            <Input className="w-32 h-8" placeholder="Customer ID" value={edit[s.msisdn] ?? ""} onChange={(e) => setEdit({ ...edit, [s.msisdn]: e.target.value })} data-testid={`wa-contact-cid-${s.msisdn}`} />
            <Button size="sm" variant="outline" onClick={() => link(s.msisdn, edit[s.msisdn])} data-testid={`wa-contact-link-${s.msisdn}`}>Link</Button>
            {s.customer_id && <Button size="sm" variant="ghost" onClick={() => link(s.msisdn, null)} data-testid={`wa-contact-unlink-${s.msisdn}`}>Unlink</Button>}
          </div>
        ))}
      </div>
    </section>
  );
}
